export var DebugType;
(function (DebugType) {
    /**
     * Debug options fallback
     */
    DebugType["Debug"] = "debug";
    /**
     * Display debug information for the configuration (objects)
     */
    DebugType["Configuration"] = "configuration";
    /**
     * Display debug information for the configuration attributes
     */
    DebugType["Attributes"] = "attributes";
    /**
     * Display debug information for the configuration values
     */
    DebugType["Values"] = "values";
    /**
     * Display debug information for the configuration attributes
     */
    DebugType["Groups"] = "groups";
    /**
     * Display debug information for the layout
     */
    DebugType["Layout"] = "layout";
    /**
     * Show debug information for other things like
     * - bill of materials
     */
    DebugType["Other"] = "other";
})(DebugType || (DebugType = {}));
//# sourceMappingURL=DebugType.js.map